// src/firebase.js
// ─────────────────────────────────────────────────
// Replace these placeholder values with your actual
// Firebase project config from the Firebase Console.
// See SETUP.md for instructions.
// ─────────────────────────────────────────────────

import { initializeApp } from 'firebase/app';
import { getDatabase, ref, get, set, runTransaction } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyDmXgUleyu745v46bdRHy1legZOGo2-aI4",
  authDomain: "daily-abstraction.firebaseapp.com",
  databaseURL: "https://daily-abstraction-default-rtdb.firebaseio.com",
  projectId: "daily-abstraction",
  storageBucket: "daily-abstraction.firebasestorage.app",
  messagingSenderId: "474092253243",
  appId: "1:474092253243:web:7062da47c27fe164836c1e"

};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

// ─── Community data (shared via Firebase) ───

export async function loadCommunityData(dateKey) {
  try {
    const snapshot = await get(ref(db, `community/${dateKey}`));
    if (snapshot.exists()) {
      return snapshot.val();
    }
    return { solves: [], starts: 0 };
  } catch (err) {
    console.error("Firebase read error:", err);
    return { solves: [], starts: 0 };
  }
}

export async function addCommunitysolve(dateKey, solveEntry) {
  try {
    const dataRef = ref(db, `community/${dateKey}`);
    await runTransaction(dataRef, (current) => {
      if (!current) current = { solves: [], starts: 0 };
      if (!current.solves) current.solves = [];
      current.solves.push(solveEntry);
      return current;
    });
  } catch (err) {
    console.error("Firebase write error:", err);
  }
}

export async function incrementCommunityStarts(dateKey) {
  try {
    const dataRef = ref(db, `community/${dateKey}`);
    await runTransaction(dataRef, (current) => {
      if (!current) current = { solves: [], starts: 0 };
      current.starts = (current.starts || 0) + 1;
      return current;
    });
  } catch (err) {
    console.error("Firebase write error:", err);
  }
}
